import {
    ENVIRONMENT,
    EVENT_REDIRECTION_URL,
    EVENT_URL,
    PREVIEW,
    eventBrandingWebsite,
    leaderBoardView,
    qaSpeakerView,
    isInstallableCMSApp,
} from 'utils/constants';
import {
    checkMobileApp,
    getPlayStoreOrAppStoreUrl,
    openLinkInNewTab,
} from 'utils/common';

const INSTALL_APP_MODAL_EXCLUDED_PATH_ROOTS = new Set([
    'logout',
    'forgot-password',
    'reset-password',
    'create-password',
    'create-new-password',
    'verify-email',
    'link-redirection',
    'registration',
    'moderation',
    'moderate',
    EVENT_URL,
    EVENT_REDIRECTION_URL,
    qaSpeakerView,
    leaderBoardView,
]);

/** Auth pages where the install modal should not appear (login screens are allowed). */
export const isExcludedInstallAppModalPath = (pathname = '') => {
    const path = pathname || window.location.pathname;

    if (
        path.includes(PREVIEW) ||
        path.includes(`/${EVENT_REDIRECTION_URL}`) ||
        path.includes(eventBrandingWebsite) ||
        path.includes(qaSpeakerView) ||
        path.includes(leaderBoardView) ||
        isInstallableCMSApp
    ) {
        return true;
    }

    const parts = path.split('/').filter(Boolean);
    if (!parts.length) {
        return false;
    }

    let startIndex = 0;
    if (parts[0] === PREVIEW) {
        startIndex = 1;
    }

    const root = parts[startIndex];

    if (root === 'login' && parts[startIndex + 1] === 'callback') {
        return true;
    }

    return INSTALL_APP_MODAL_EXCLUDED_PATH_ROOTS.has(root);
};

/** Whether the install modal may appear (dismissal is session-only in App.js). */
export const shouldShowInstallAppModal = (pathname = '') =>
    !checkMobileApp() && !isExcludedInstallAppModalPath(pathname);

export const getAppSchemeUrl = (eventId = '') =>
    `${window.location.origin}/${EVENT_URL}/${eventId || ''}`;

export const openNativeApp = (eventId = '') => {
    const environment = ['demo', 'staging'].includes(ENVIRONMENT)
        ? 'development'
        : ENVIRONMENT;
    const customScheme = `covision-${environment}`;
    const appSchemeUrl = getAppSchemeUrl(eventId);
    const androidOriOSLink = document.createElement('a');
    androidOriOSLink.href = appSchemeUrl
        .replace('https', customScheme)
        .replace('http', customScheme);
    try {
        if (androidOriOSLink?.click) {
            androidOriOSLink.click();
        }
    } catch (error) {
        console.log('error', error);
    } finally {
        androidOriOSLink.remove();
    }
};

export const openAppStoreForInstall = () => {
    const { playStoreOrAppStoreUrl } = getPlayStoreOrAppStoreUrl();
    openLinkInNewTab(playStoreOrAppStoreUrl, true);
};
